interface StorageCellI {
  [key: string]: string;
}

const getSorageCell = (sKey: string): StorageCellI | undefined => {
  const cellString = localStorage.getItem(sKey);
  let cellObj: StorageCellI | undefined;
  if (!cellString) {
    return undefined;
  }
  try {
    cellObj = JSON.parse(cellString);
  } catch {
    return undefined;
  }
  return cellObj;
};

const lStorage = {
  getItem: (sKey: string, key: string): string | undefined => {
    const cellObj = getSorageCell(sKey);
    return cellObj ? cellObj[key] : undefined;
  },
  setItem: (sKey: string, key: string, value: string) => {
    const cellObj = getSorageCell(sKey);
    let cellString: string;

    cellString = JSON.stringify(cellObj ? { ...cellObj, [key]: value } : { [key]: value });

    localStorage.setItem(sKey, cellString);
  },
  removeItem: (sKey: string, key: string) => {
    const cellObj = getSorageCell(sKey);
    if (cellObj) {
      delete cellObj[key];
      localStorage.setItem(sKey, JSON.stringify(cellObj));
    }
  },
};

export default lStorage;
